<template>
	<div id="app">
		<navBar></navBar>
		<transition name="fade" mode="out-in">
			<router-view />
		</transition>
	</div>
</template>

<script>
import navBar from '@/components/NavBar.vue';

export default {
	components: {
		navBar
	}
};
</script>

<style>
/* @import "~bootstrap/dist/css/bootstrap.min.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css"; */

@font-face {
	font-family: 'avalon_xlight';
	src: url('/fonts/Avalon-XLight-webfont.eot');
	src: url('/fonts/Avalon-XLight-webfont.eot?#iefix') format('embedded-opentype'),
		url('/fonts/Avalon-XLight-webfont.woff2') format('woff2'),
		url('/fonts/Avalon-XLight-webfont.woff') format('woff'),
		url('/fonts/Avalon-XLight-webfont.ttf') format('truetype'),
		url('/fonts/Avalon-XLight-webfont.svg#avalonextra_light') format('svg');
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: 'avalon_book';
	src: url('/fonts/Avalon-Book-webfont.eot');
	src: url('/fonts/Avalon-Book-webfont.eot?#iefix') format('embedded-opentype'),
		url('/fonts/Avalon-Book-webfont.woff2') format('woff2'), url('/fonts/Avalon-Book-webfont.woff') format('woff'),
		url('/fonts/Avalon-Book-webfont.ttf') format('truetype'),
		url('/fonts/Avalon-Book-webfont.svg#avalonregular') format('svg');
	font-weight: normal;
	font-style: normal;
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-family: 'Roboto', sans-serif;
	color: black;
	font-size: 16px;
	text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
}

.avalon {
	font-size: 24px;
	font-family: 'avalon_xlight', sans-serif;
}

.jumbotron {
	padding-top: 50px;
	padding-bottom: 20px;
	border-radius: 0;
}

/*section {
    padding-top: 60px;
}*/

h1 {
	font-family: 'avalon_xlight', sans-serif;
	font-size: 42px;
	font-weight: bold;
	text-align: center;
	padding-bottom: 20px;
}

h2 {
	font-family: 'avalon_xlight', sans-serif;
	font-size: 32px;
	font-weight: bold;
	color: #0099a7;
	text-align: center;
}

h2 a {
	color: #0099a7;
}

h2 a:hover {
	color: #0099a7;
}

p {
	line-height: 28px;
}

.pt-60 {
	padding-top: 60px;
}

.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>
